import { css } from '@emotion/react';
import { SectionTitle } from '@/components/general/SectionTitle';
import { ButtonLink } from '@/components/shared/ButtonLink';
import {
  FeatureCard1,
  FeatureCard2,
  FeatureCard3,
  FeatureCard4,
  FeatureCard5,
  FeatureCard6,
  FeatureCard7,
} from '@/components/top-page/FeatureCard';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import {} from './FeatureCard';
import { withPrefix } from 'gatsby';

export type WhatsUniforceSectionProps = {
  className?: string;
};

export const WhatsUniforceSection: React.FC<WhatsUniforceSectionProps> = ({
  className,
}) => {
  return (
    <section id="wats"
      css={css`
        position: relative;
        z-index: 1;
        background: linear-gradient(
          196deg,
          #f0fcfb 0%,
          #f8fffe 49%,
          #ffffff 100%
        );
        padding: 72px 20px 108px;

        @media ${getScreen('pc')} {
          background: linear-gradient(
            220deg,
            #def6f5 0%,
            #f0fcfb 22%,
            #ffffff 100%
          );
          padding: 136px 20px 144px;
          overflow: hidden;
        }
      `}
      className={className}
    >
      <div
        css={css`
          position: absolute;
          top: 214px;
          left: calc(50% + 230px);
          z-index: -1;

          @media ${getScreen('pc', '未満')} {
            display: none;
          }
        `}
      >
        <img
          src={withPrefix('/images/page-background.png')}
          width="813"
          height="797"
          alt=""
        />
      </div>
      <div
        css={css`
          position: absolute;
          top: 1526px;
          right: calc(50% + 230px);
          z-index: -1;

          @media ${getScreen('pc', '未満')} {
            display: none;
          }
        `}
      >
        <img
          src={withPrefix('/images/page-background.png')}
          width="813"
          height="797"
          alt=""
        />
      </div>
      <SectionTitle
        en="WHAT’S UNIFORCE"
        subText={
          <p>
            IPO支援をしてきた公認会計士が設計した
            <wbr />
            ITとコンサルの両軸から
            <br />
            イグジット (出口)戦略をサポートします。
          </p>
        }
      >
        <img
          css={css`
            vertical-align: middle;
            margin-right: 6px;
            width: 140px;
            height: auto;
            transform: translateY(-1px);

            @media ${getScreen('pc')} {
              width: 195px;
              margin-right: 10px;
              transform: translateY(-2px);
            }
          `}
          src={withPrefix('/images/logo-line.svg')}
          width="195"
          height="45"
          alt="Uniforce"
        />
        <span
          css={css`
            color: #2b2c40;
          `}
        >
          の特徴
        </span>
      </SectionTitle>
      <div
        css={css`
          margin-top: 70px;
          display: flex;
          flex-direction: column;
          gap: 88px;

          @media ${getScreen('pc')} {
            gap: 192px;
          }
        `}
      >
        <FeatureCard1 />
        <FeatureCard6 />
        <FeatureCard5 />
        
        <FeatureCard4 />
        
        <FeatureCard3 />
        <FeatureCard2 />
        <FeatureCard7 />
      </div>
      <ButtonLink
        css={css`
          margin: 80px 20px 0;

          @media ${getScreen('pc')} {
            width: 221px;
            margin: 120px auto 0;
          }
        `}
        to={pagesPath.tool.$url()}
        variant="top-more"
      >
        機能一覧
      </ButtonLink>
    </section>
  );
};
